import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { reportEntities } from './types';

import { requestReportEntitiesSuccess, requestReportEntitiesFailure } from './reducer';

const logger = new Logger('Saga:UserReport:ReportEntities');

export function* requestReportEntities() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.teams.report_entities'),
    );

    yield put(requestReportEntitiesSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request report entities with the following error', error);
    yield put(requestReportEntitiesFailure(error));
  }
}

export default function* reportEntitiesSaga() {
  return yield all([takeLatest(reportEntities.request, requestReportEntities)]);
}
